import { z } from 'zod';
function isValidTimezone(tz) {
    try {
        new Intl.DateTimeFormat(undefined, { timeZone: tz });
        return true;
    }
    catch (_a) {
        return false;
    }
}
/** Development only: create an organisation with no external accounting system */
export const createInternalOrganisationRequestSchema = z.object({
    legalName: z.string().trim().min(1),
    region: z.string().trim().toUpperCase().regex(/^[A-Z]{2}$/, `must be a 2 letter country code`),
    baseCurrency: z.string().trim().toUpperCase().regex(/^[A-Z]{3}$/, `must be a 3 letter currency code`),
    timezone: z.string().refine(isValidTimezone, `must be a valid IANA timezone`),
});
//# sourceMappingURL=organisation.js.map